"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = require("react");
var layout_1 = require("../layout");
var Styles_1 = require("./Styles");
var Modal = function (_a) {
    var onRequestClose = _a.onRequestClose, isOpen = _a.isOpen, children = _a.children, props = __rest(_a, ["onRequestClose", "isOpen", "children"]);
    var backdropEl = react_2.useRef(null);
    var theme = react_1.useTheme();
    var style = react_2.useMemo(function () { return Styles_1.createModalStyle(theme); }, [theme]);
    var handleClick = react_2.useCallback(function (e) {
        if (onRequestClose && e.target === backdropEl.current) {
            onRequestClose();
        }
    }, [backdropEl, onRequestClose]);
    var keyPressHandler = react_2.useCallback(function (e) {
        if (onRequestClose && e.key === 'Escape') {
            onRequestClose();
        }
    }, [onRequestClose]);
    react_2.useEffect(function () {
        window.addEventListener('keydown', keyPressHandler);
        return function () {
            window.removeEventListener('keydown', keyPressHandler);
        };
    }, [keyPressHandler]);
    return isOpen ? (react_1.jsx("div", __assign({ css: style.backdropStyle, onClick: handleClick }, props),
        react_1.jsx(layout_1.Grid, { ref: backdropEl, templateRows: "1fr min-content 1fr", templateColumns: "1fr min-content 1fr", gap: 20, css: style.gridStyle },
            react_1.jsx(layout_1.Grid.Cell, { row: "2", column: "2" }, children)))) : null;
};
exports.default = Modal;
